import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { updateDb } from "../services/updateDb";

import LoadPage from "../common/LoadPage";
import AlertMessage from "../common/AlertMessage";
import ConfirmationModal from "../common/ConfirmationModal";
import useAxiosFetch from "../common/useAxiosFetch";
import { Button } from "react-bootstrap";
import { useAppContext } from "../AppContext";

const CoPilotManagementPage = () => {
    const { data, loading, refetch } = useAxiosFetch("/api/copilot");
    const { alertMessage, showAlertMessage, triggerHeaderRefresh } = useAppContext();
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const [deleteQuestion, setDeleteQuestion] = useState();

    const handleClose = async (deleteQuestion, copilotId) => {
        setShow(false);

        if (deleteQuestion && copilotId) {
            const res = await updateDb("/api/copilot/" + copilotId, {}, "delete");

            if (res.success) {
                triggerHeaderRefresh();
                refetch();
                showAlertMessage("error", "Question successfully deleted.");
            } else {
                showAlertMessage("error", res.error ? res.error : "Error deleting question.");
            }
        }
    };

    const handleShow = (copilotId) => {
        setDeleteQuestion(copilotId);
        setShow(true);
    };

    let navigateEditCopilot = (copilotId) => {
        navigate(`/editcopilot?copilotId=${copilotId}`);
    };

    if (loading) return <LoadPage />;

    return (
        <div id="content">
            <div id="content-title">Copilot Questions</div>

            <div className="clear-both" />

            <ConfirmationModal show={show} handleClose={handleClose} deleteId={deleteQuestion} />

            <NavLink key="addCopilot" to="/addcopilot">
                <Button className="add-btn btn-right-top" variant="primary" type="button">
                    +
                </Button>
            </NavLink>

            <AlertMessage type={alertMessage.type} message={alertMessage.content} />

            <div className="content-bubble content-bubble-table">
                <table className="overview-table">
                    <thead>
                        <tr>
                            <td>Description</td>
                            <td>Prompt</td>
                            <td>Icon</td>
                            <td>Data</td>
                            <td>Enabled</td>
                            <td width="80"/>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item) => {
                            return (
                                <tr key={item["id"]}>
                                    <td>{item.description}</td>
                                    <td>{item.prompt}</td>
                                    <td>{item.icon && (<i className={item.icon} style={{fontSize: 36}}/>)}</td>
                                    <td>{item.data}</td>
                                    <td>{item.enabled == true ? "Yes" : "No"}</td>
                                    <td>
                                        <i onClick={() => navigateEditCopilot(item["id"])} className="icon-edit" />
                                        <i onClick={() => handleShow(item["id"])} className="icon-delete" />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CoPilotManagementPage;
